import { Report } from "./report";
import { Timecode } from "./time-code";
import { MetaData } from "./meta-data";

/* tslint:disable:no-string-literal */
export class ReportHelper extends Report {
  // Video EVENT codes
  static EVENT_VIDEO_START = "Video_Commence";
  static EVENT_VIDEO_COMPLETE = "Video_Complete";
  static EVENT_VIDEO_PROGRESS = "Video_Update";
  static EVENT_VIDEO_INTERACTION = "Video_Interact";
  static EVENT_VIDEO_ERROR = "Video_Error_Display";
  static EVENT_VIDEO_FEEDBACK = "Video_Feedback";
  static EVENT_VIDEO_IMPRESSION = "Video_Impression";
  videoData: MetaData;
  isClicked: boolean = false;
  videoStart: boolean = true;
  timeInit = Date.now();
  timeLoad: any;
  timeWaiting: any;
  timeCanPlay: any;
  timeCanPlayThrough: any;
  loadEvent = "waiting";
  waitTime: any;
  seekTimer: any = null;
  videoprogress: any = 0;

  contollerActions = [
    "Pause Button",
    "Play Button",
    "Mute Toggle",
    "Captions Toggle",
    "Full screen Toggle",
    "Transcript Toggle",
    "Seek Slider",
    "Volume Slider",
  ];
  transcriptActions = ["Transcript Print Button", "Text", "Transcript Slider"];
  // 'Transcript Search Button',
  videoActions = ["Close Transcript", "Print Transcript", "Content Filter"];
  sliderActions = ["Seek Slider", "Volume Slider", "Transcript Slider"];
  feedbackReport = ["feedback", "Thumbs up", "Thumbs down", "starRating"];

  constructor(target?: HTMLElement, metaData?: MetaData, isClicked?: boolean) {
    super();
    this.videoData = metaData!;
    this.target = target!;
    this.isClicked = isClicked ? isClicked : false;
  }

  set target(input: HTMLElement) {
    //    const that=this;
    if (!input) {
      return;
    }
    if (
      input.attributes["data-name" as any] &&
      input.attributes["data-name" as any].value === "ErrorView"
    ) {
      const jsonOutput = {
        errorType: "",
        mediaId: "",
        mediaPlayerName: "",
        statusMessage: "",
        successFlag: "",
      };
      jsonOutput["mediaId"] = this.videoData?.id;
      jsonOutput["mediaPlayerName"] = "AT&T GVP 4";
      jsonOutput["successFlag"] = "0";
      jsonOutput["errorType"] = this.videoData?.state; // ('state');
      //  jsonOutput['statusMessage']='Video ID is invalid';
      if ("Failure_ID_Expired" === this.videoData?.state) {
        jsonOutput["statusMessage"] = "Video ID is expired (EOL)";
      } else if (this.videoData?.state === "Failure_ID_Invalid") {
        jsonOutput["statusMessage"] = "Video ID is invalid";
      }
      this.sendReport(ReportHelper.EVENT_VIDEO_ERROR, jsonOutput);
      return;
    }
    window.onbeforeunload = () => {
      if (window["CustomEvent"]) {
        const event = new CustomEvent("closed");
      } else {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent("closed", true, true, {});
      }
      input.dispatchEvent(event!);
    }; // attach event beforeunload
    const video: any =
      input.id && input.id.indexOf("videoPlayer") !== -1
        ? input
        : input.querySelector("video");

    input.addEventListener("closed", (event: any) => {
      this.handleCloseEvent(video);
    });

    video.addEventListener("timeupdate", () => {
      if (this.videoStart) {
        // send video commence
        const jsonOutput = this.getCommonValues();
        // @ts-ignore: TODO
        jsonOutput["videoLaunchDate"] = this.launchDate(this.videoData?.date);
        jsonOutput["videoAutoPlayFlag"] = "0";
        jsonOutput["statusCode"] = "0";
        if (!this.isClicked) {
          this.sendReport(ReportHelper.EVENT_VIDEO_START, jsonOutput);
        }
        this.videoStart = false;
      }
      this.videoprogress =
        Math.floor(
          100 *
            (video.currentTime /
              Timecode.timecodeToSeconds(this.videoData?.duration))
        ) + "%";
    });

    "waiting canplaythrough loadstart ended seeking click"
      .split(" ")
      .forEach((e: string) => {
        video.addEventListener(e, (event: Event) => {
          setTimeout(() => {
            this.handleVideoEvent(event, video);
          }, 1);
        });
      });
  }

  handleCloseEvent(video: any, isExplicitTrigger?: boolean) {
    if (isExplicitTrigger) {
      video =
        video.id && video.id.indexOf("videoPlayer") !== -1
          ? video
          : video.querySelector("video");
    }
    const jsonOutput = this.getCommonValues();
    jsonOutput["videoProgressType"] = "Milestone";
    jsonOutput["videoProgressPercent"] = this.videoprogress;
    jsonOutput["videoBufferTime"] = Math.floor(this.getWaitTime(this.waitTime));
    jsonOutput["videoLengthViewed"] = Math.floor(video.currentTime);
    jsonOutput["statusCode"] = "0";
    this.sendReport(ReportHelper.EVENT_VIDEO_PROGRESS, jsonOutput);
  }

  handlePlayPauseEvent(event: any) {
    const jsonOutput = this.getCommonValues();
    (jsonOutput["videoControlAction"] = "Click"),
      (jsonOutput["videoControlName"] = event ? "Play Button" : "Pause Button"),
      (jsonOutput.videoControlLocation = "video"),
      this.sendReport(ReportHelper.EVENT_VIDEO_INTERACTION, jsonOutput);
  }

  handleVideoEvent(event: any, video: any) {
    switch (event.type) {
      case "ended":
        const jsonOutput = this.getCommonValues();
        jsonOutput["videoProgressType"] = "Milestone";
        this.videoprogress = 100;
        jsonOutput["videoProgressPercent"] = this.videoprogress;
        jsonOutput["videoBufferTime"] = Math.floor(
          this.getWaitTime(this.waitTime)
        );
        jsonOutput["videoLengthViewed"] = Math.floor(video.currentTime);
        jsonOutput["statusCode"] = "0";
        this.sendReport(ReportHelper.EVENT_VIDEO_PROGRESS, jsonOutput);
        // to send video commence again on replay
        this.videoStart = true;
        break;
      case "loadstart":
        this.loadEvent = "loadstart";
        this.timeLoad = Date.now();
        break;
      case "waiting":
        this.loadEvent = "waiting";
        this.timeWaiting = Date.now();
        break;
      case "canplaythrough":
        this.timeCanPlayThrough = Date.now();
        if (this.loadEvent === "waiting") {
          this.waitTime = this.timeCanPlayThrough - this.timeWaiting;
        } else {
          this.waitTime = this.timeCanPlayThrough - this.timeLoad;
        }
        break;
      case "error":
        const errorOutput = this.getCommonValues();
        errorOutput["mediaId"] = this.videoData?.id;
        errorOutput["mediaPlayerName"] = "AT&T GVP 4";
        errorOutput["successFlag"] = "0";
        errorOutput["errorType"] = "Failure_Playback";
        errorOutput["statusMessage"] =
          "Catch all for any other playback related issues";
        this.sendReport(ReportHelper.EVENT_VIDEO_ERROR, errorOutput);
        break;
    }
  }

  getCommonValues() {
    const jsonOutput = {
      errorType: "",
      feedbackComments: "",
      feedbackRating: "",
      mediaCategory: "",
      mediaFriendlyName: "",
      mediaId: "",
      mediaPlayerName: "",
      recommendedVideoFriendlyName: "",
      recommendedVideoId: "",
      starRating: "",
      statusCode: "",
      statusMessage: "",
      successFlag: "",
      videoAutoPlayFlag: "",
      videoBufferTime: 0,
      videoControlAction: "",
      videoControlActionValue: 0,
      videoControlLinkUrl: "",
      videoControlLocation: "",
      videoControlName: "",
      videoDescription: "",
      videoLaunchDate: "" || undefined,
      videoLengthTotal: 0,
      videoLengthViewed: 0,
      videoProgressPercent: "",
      videoProgressType: "",
    };
    jsonOutput["mediaId"] = this.videoData?.id;
    jsonOutput["mediaFriendlyName"] = this.videoData?.title;
    jsonOutput["videoDescription"] = this.videoData?.description;
    jsonOutput["videoLengthTotal"] = this.hmsToSecondsOnly(
      this.videoData?.duration
    );
    jsonOutput["mediaCategory"] = this.getCategory(this.videoData?.category);
    jsonOutput["mediaPlayerName"] = "AT&T GVP 4";
    jsonOutput["successFlag"] = "1";
    jsonOutput["errorType"] = "Success_Admit";
    return jsonOutput;
  }

  getCategory(value: any) {
    if (value && value.length > 1) {
      let text: string = "";
      let i;
      for (i = 0; i < value.length; i++) {
        text += i === 0 ? value[i] : "~" + value[i];
      }
      return text;
    } else {
      return value;
    }
  }

  hmsToSecondsOnly(str: any) {
    const p = str.split(":");
    let s = 0;
    let m = 1;

    while (p.length > 0) {
      s += m * parseInt(p.pop(), 10);
      m *= 60;
    }

    return s;
  }

  getWaitTime(waitTime: any): any {
    if (typeof waitTime === "undefined" || waitTime < 100) {
      return "00";
    } else {
      return waitTime / 1000;
    }
  }

  launchDate(launchDate: any) {
    if (!launchDate) {
      return;
    }
    const d = new Date(launchDate);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = "0" + month;
    }
    if (day.length < 2) {
      day = "0" + day;
    }
    return [year, month, day].join("");
  }

  getVideoContollerName(key: any) {
    const contollerName = {
      "Close Transcript": "Transcript Toggle",
      "Close Video": "",
      "Closed Captions": "Captions Toggle",
      "Content Filter": "Transcript Search Button",
      "Fullscreen Video": "Full screen Toggle",
      "Mute Video": "Mute Toggle",
      "Pause Video": "Pause Button",
      "Play Video": "Play Button",
      "Print Transcript": "Transcript Print Button",
      "Seek Video": "Seek Slider",
      "Unmute Video": "Mute Toggle",
      "Video Transcript": "Transcript Toggle",
      "Video Volume": "Volume Slider",
      // 'Seek Slider'
      // 'Volume Slider'
      // 'Text'
    };
    // @ts-ignore: TODO
    return contollerName[key];
  }

  getCotrllerToggleValues(control: any, value: any) {
    if (control && "Captions Toggle" === control) {
      if (value === "true") {
        return "Off";
      } else {
        return "On";
      }
    } else if (control && "Full screen Toggle" === control) {
      if (value === "true") {
        return "Disabled";
      } else {
        return "Enabled";
      }
    } else if (control && "Transcript Toggle" === control) {
      if (value === "false") {
        return "Open";
      } else {
        return "Close";
      }
    } else if (control && "Mute Toggle" === control) {
      if (value === "true") {
        return "On";
      } else {
        return "Off";
      }
    }
  }

  getVideoControlLocation(key: any) {
    if (this.contollerActions.indexOf(key) > -1) {
      return "Controller";
    } else if (this.transcriptActions.indexOf(key) > -1) {
      return "Transcript";
    } else {
      return "Video";
    }
  }
}
